import { BaseLink } from "~/design-system/components/link";
import { URLS } from "~/shared/urls";

export function ErrorActions() {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
      <BaseLink
        to={URLS.home}
        className="bg-primary-800 hover:bg-primary-700 focus:ring-primary-500 inline-flex items-center justify-center rounded-md px-6 py-3 font-medium text-white transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none"
      >
        Go to Homepage
      </BaseLink>
      <button
        onClick={handleGoBack}
        type="button"
        className="focus:ring-primary-500 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-3 font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:ring-2 focus:ring-offset-2 focus:outline-none"
      >
        Go Back
      </button>
    </div>
  );
}
